import { Component, Input, OnInit, Inject } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CommonServices } from "src/app/common.services";
import { Router } from "@angular/router";
import { TruckOwnerService } from "../truck-owner.service";

@Component({
  selector: "app-add-credit-trip",
  templateUrl: "./add-credit-trip.component.html",
  styleUrls: ["./add-credit-trip.component.css"],
})
export class AddCreditTripComponent implements OnInit {
  loading: boolean = false;
  date = new FormControl(new Date());
  serializedDate = new FormControl(new Date().toISOString());
  today: any;
  minDate = new Date();
  @Input() max: any;
  maxDate = new Date();
  addCreditForm: FormGroup;
  token: any;
  vehicleArray: any;
  selectedVehicleValue: any;
  vehicleList: any;
  doId: any;
  workOrderQnty: any;
  work_order_qty: any;
  total_quantity: any;
  unloadingQty: any;
  loadingQty: any;

  constructor(
    private matdialogref: MatDialogRef<AddCreditTripComponent>,
    private formBuilder: FormBuilder,
    private services: TruckOwnerService,
    private commonServices: CommonServices,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private snackBar: MatSnackBar
  ) {
    this.maxDate.setDate(this.maxDate.getDate() - 0);
  }

  ngOnInit(): void {
    this.token = sessionStorage.getItem("to_token");

    this.addCreditForm = this.formBuilder.group({
      truck_id: ["", [Validators.required]],
      driver_id: ["", [Validators.required]],
      loading_point: ["", [Validators.required]],
      unloading_point: [""],
      price_per_ton: [""],
      sales_order_number: [""],
      lr_number: ["", [Validators.required]],
      lr_date: ["", [Validators.required]],
      tax_invoice_no: [""],
      ddc_no: [""],
      tripbooking_date: [""],
      remaining_tons: [""],
      workorder_qty: [""],
      mobile: [""],
    });
    this.vehicleGet();
    if (this.data) {
      this.total_quantity = this.data.remaining_tons;

      this.addCreditForm.patchValue({
        remaining_tons: this.data.remaining_tons.toFixed(3),
        workorder_qty: this.data.do_quantity.toFixed(3),
        sales_order_number: this.data.sales_order_no,
        price_per_ton: this.data.price_per_ton,
      });
      // if (this.data.pay_as_load_quantity === "unloaded_quantity") {
      //   this.unloadingQty = "unloaded_quantity";
      //   // this.editworkform.controls["loading_point"].disable();
      //   this.addCreditForm.controls["loading_point"].reset();
      //   this.addCreditForm.controls["unloading_point"].enable();
      //   this.addCreditForm.controls["loading_point"].disable();
      // } else {
      //   this.addCreditForm.controls["unloading_point"].disable();
      //   this.addCreditForm.controls["unloading_point"].reset();
      //   this.addCreditForm.controls["loading_point"].enable();
      //   this.loadingQty = "loading_point";
      // }
    }
  }

  validateTaxInvoiceInput(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    const charStr = String.fromCharCode(charCode);
    const pattern = /^[a-zA-Z0-9/-]*$/;
    if (!pattern.test(charStr)) {
      event.preventDefault();
    }
  }

  close() {
    this.matdialogref.close();
  }

  // function to handle dropdown opening
  // onDropdownOpened(item: any) {

  //   if (this.vehicleArray.length === 0) {
  //     this.snackBar.open("No Trucks Are Available For This WorkOrder", "Fail", {
  //       duration: 5000,
  //     });
  //   }
  // }

  // vehicleGet() {
  //   this.services
  //     .getVehicleDetails(this.token, this.data._id)
  //     .subscribe((response: any) => {
  //       this.vehicleArray = response.body;
  //       if (this.vehicleArray.length == 0) {
  //         this.snackBar.open(
  //           "No Trucks Are Available For This WorkOrder",
  //           "Fail",
  //           {
  //             duration: 5000,
  //           }
  //         );
  //       }
  //     });
  // }

  vehicleGet() {
    this.services
      .getVehicleDetails(
        this.token,
        this.data.workorderInfo[0]?.truck_category._id
      )
      .subscribe((response: any) => {
        this.vehicleArray = response.body;
        if (this.vehicleArray.length == 0) {
          this.snackBar.open(
            "No Trucks Are Available For This WorkOrder",
            "Fail",
            {
              duration: 5000,
            }
          );
        }
        // else {
        //   const isTruckAllocated = this.vehicleArray.some(
        //     (vehicle: any) => vehicle.truck_status === "trip_booked"
        //   );
        //   if (isTruckAllocated) {
        //     this.snackBar.open(
        //       "Truck Is Already Allocated Please Select Another Truck",
        //       "Fail",
        //       {
        //         duration: 5000,
        //       }
        //     );
        //   }
        // }
      });
  }

  getDriverList(item: any) {
    this.selectedVehicleValue = item.value;
    const isTruckAllocated = this.vehicleArray.some(
      (vehicle: any) =>
        this.selectedVehicleValue == vehicle._id &&
        vehicle.truck_status === "trip_booked"
    );
    if (isTruckAllocated) {
      this.snackBar.open(
        "Truck Is Already Allocated Please Select Another Truck",
        "Fail",
        {
          duration: 5000,
        }
      );
      return;
    }
    this.services.GetVehicle(this.selectedVehicleValue, this.token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.vehicleList = response.body.data;
          this.addCreditForm.patchValue({
            driver_id: this.vehicleList.driverInfo[0]?.username,
            mobile: this.vehicleList.driverInfo[0]?.mobile,
          });
        }
      },
      (error) => {
        if (error.status == 403 || 401) {
          this.router.navigateByUrl("/");
          sessionStorage.clear();
        }
        if (error.error.message === "jwt malformed || jwt expired") {
          this.router.navigateByUrl("/");
          sessionStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  remainingQnty(event: any) {
    this.workOrderQnty = event.target.value;
    this.work_order_qty = this.total_quantity - this.workOrderQnty;
    if (this.work_order_qty >= 0 || this.workOrderQnty == this.work_order_qty) {
      this.addCreditForm.patchValue({
        remaining_tons: (this.total_quantity - this.workOrderQnty).toFixed(3),
      });
    } else {
      this.addCreditForm.patchValue({
        remaining_tons: this.total_quantity.toFixed(3),
      });
      this.snackBar.open(
        "Work Order Quantity Should not Exceed With Remaining Quantity",
        "Fail",
        {
          duration: 5000,
        }
      );
    }
  }

  validateUnloadingPoint() {
    const loadingPoint = parseFloat(this.addCreditForm.value.loading_point);
    const unloadingPoint = parseFloat(this.addCreditForm.value.unloading_point);

    const unloadingPointControl = this.addCreditForm.get("unloading_point");

    if (unloadingPointControl) {
      if (unloadingPoint > loadingPoint) {
        unloadingPointControl.setErrors({ greaterThanLoading: true });
        this.snackBar.open(
          "Unloading Point cannot exceed Loading Point",
          "Close",
          {
            duration: 3000,
          }
        );
      } else {
        unloadingPointControl.setErrors(null);
      }
    }
  }

  addTrip() {
    let driver = this.addCreditForm.value.driver_id;
    if (!driver) {
      this.snackBar.open("Please select vehicle number", "Fail", {
        duration: 5000,
      });
      return;
    }
    let bookingDate = this.addCreditForm.value.tripbooking_date;
    if (!bookingDate) {
      this.snackBar.open("Please select trip booking date", "Fail", {
        duration: 5000,
      });
      return;
    }
    let workOrderQty = this.addCreditForm.value.workorder_qty;
    if (!workOrderQty) {
      this.snackBar.open("Please enter workorder quantity", "Fail", {
        duration: 5000,
      });
      return;
    }
    let loading = this.addCreditForm.value.loading_point;
    if (this.data.pay_as_load_quantity == "loaded_quantity") {
      if (!loading) {
        this.snackBar.open("Please enter loading point", "Fail", {
          duration: 5000,
        });
        return;
      }
    }
    let unloading = this.addCreditForm.value.unloading_point;
    if (this.data.pay_as_load_quantity == "unloaded_quantity") {
      if (!unloading) {
        this.snackBar.open("Please enter unloading point", "Fail", {
          duration: 5000,
        });
        return;
      }
    }
    let priceperton = this.addCreditForm.value.price_per_ton;
    if (!priceperton) {
      this.snackBar.open("Please enter price per ton", "Fail", {
        duration: 5000,
      });
      return;
    }
    let salesorder = this.addCreditForm.value.sales_order_number;
    if (!salesorder) {
      this.snackBar.open("Please enter sales order number", "Fail", {
        duration: 5000,
      });
      return;
    }
    let lrnumber = this.addCreditForm.value.lr_number;
    if (!lrnumber) {
      this.snackBar.open("Please enter lr number", "Fail", {
        duration: 5000,
      });
      return;
    }
    let lrDate = this.addCreditForm.value.lr_date;
    if (!lrDate) {
      this.snackBar.open("Please select lr date", "Fail", {
        duration: 5000,
      });
      return;
    }
    let taxInvoice = this.addCreditForm.value.tax_invoice_no;
    if (!taxInvoice) {
      this.snackBar.open("Please enter tax invoice number", "Fail", {
        duration: 5000,
      });
      return;
    }
    let ddcnumber = this.addCreditForm.value.ddc_no;
    if (!ddcnumber) {
      this.snackBar.open("Please enter ddc number", "Fail", {
        duration: 5000,
      });
      return;
    }

    const isTruckAllocated = this.vehicleArray.some(
      (vehicle: any) =>
        this.selectedVehicleValue == vehicle._id &&
        vehicle.truck_status === "trip_booked"
    );
    if (isTruckAllocated) {
      this.snackBar.open(
        "Truck Is Already Allocated Please Select Another Truck",
        "Fail",
        {
          duration: 5000,
        }
      );
      return;
    }

    const otherDetails = {
      loading_point: Number(this.addCreditForm.value.loading_point) || 0,
      unloading_point: Number(this.addCreditForm.value.unloading_point) || 0,
      price_per_ton: Number(this.addCreditForm.value.price_per_ton),
      sales_order_number: this.addCreditForm.value.sales_order_number,
      lr_number: this.addCreditForm.value.lr_number,
      lr_date: this.addCreditForm.value.lr_date,
      tax_invoice_no: this.addCreditForm.value.tax_invoice_no,
      ddc_no: this.addCreditForm.value.ddc_no,
    };
    const creditTripObj = {
      truck_id: this.addCreditForm.value.truck_id,
      driver_id: this.vehicleList.driverInfo[0]?._id,
      driver_ref_id: this.vehicleList.driverInfo[0]?._id,
      other_details: otherDetails,
      remaining_tons: Number(this.addCreditForm.value.remaining_tons),
      workorder_qty: Number(this.addCreditForm.value.workorder_qty),
      tripbooking_date: this.addCreditForm.value.tripbooking_date,
      do_id: this.data._id,
    };

    if (otherDetails.loading_point > this.addCreditForm.value.workorder_qty) {
      this.snackBar.open(
        "Loading point should not greater than work order qty",
        "Fail",
        {
          duration: 5000,
        }
      );
      return;
    }
    if (otherDetails.unloading_point > this.addCreditForm.value.workorder_qty) {
      this.snackBar.open(
        "Un Loading point should not greater than work order qty",
        "Fail",
        {
          duration: 5000,
        }
      );
      return;
    }

    this.services
      .addCreditTrip(this.data.workorderInfo[0]?._id, creditTripObj, this.token)
      .subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.close();
            this.snackBar.open(
              "Trip has been created to this work order",
              this.data.workorderInfo[0]?.workorder_id,
              {
                duration: 5000,
              }
            );
            this.router.navigateByUrl("/transporter/orders");
            this.commonServices.publishMessage(
              "tripAssigned",
              response.body.data
            );
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed || jwt expired") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
}
